export default {
  title: 'Treasury',
  rule: 'Rules',
  NegativeValue: 'Banks and funds can be negative',

  notifications: {
    negativeBalanceError: 'Due to the negative balance of a number of banks or funds, the desired settings were saved with an error',

    edit: {
      success: 'Treasury information has been updated successfully',
      error: 'Update treasury information has error'
    }
  }
}
